import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, User, Store, Shield, ClipboardList } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';

export default function MobileNav() {
  const location = useLocation();
  const { user, openSignIn } = useAuth();
  const { getItemCount } = useCart();
  const itemCount = getItemCount();

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/checkout', icon: ShoppingBag, label: 'Cart', badge: itemCount },
    { path: '/orders', icon: ClipboardList, label: 'Orders' },
    ...(user?.role === 'vendor'
      ? [{ path: '/dashboard', icon: Store, label: 'Dashboard' }]
      : []),
    ...(user?.role === 'admin'
      ? [{ path: '/admin', icon: Shield, label: 'Admin' }]
      : []),
    { path: '/profile', icon: User, label: 'Profile' }
  ];

  return (
    <nav
      className="fixed left-0 right-0 bg-card border-t md:hidden z-[60]"
      style={{
        bottom: '0px',
      }}
    >
      <div className="flex items-center justify-around h-16">
        {navItems.map(item => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-1 p-2 relative ${
                isActive ? 'text-primary' : 'text-muted-foreground'
              }`}
              data-testid={`nav-${item.label.toLowerCase()}`}
              onClick={(e) => {
                // For protected routes, route to sign-in if the user isn't authenticated.
                if (!user && (item.path === '/checkout' || item.path === '/orders' || item.path === '/profile' || item.path === '/dashboard' || item.path === '/admin')) {
                  e.preventDefault();
                  openSignIn();
                }
              }}
            >
              <Icon className="w-5 h-5" />
              <span className="text-xs">{item.label}</span>
              {item.badge > 0 && (
                <span className="absolute top-1 right-1 w-4 h-4 rounded-full bg-primary text-primary-foreground text-[10px] flex items-center justify-center">
                  {item.badge}
                </span>
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
